import React, { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { withFirebase } from "../../firebase";
import Labels from ".";
import axios from "axios";
import { useTranslation } from "react-i18next";

const LabelsContainer = ({ firebase }) => {
	const { t } = useTranslation();
	const [preloader, setPreloader] = useState(false);
	const [labels, setLabels] = useState(null);
	const [currentCity, setCurrentCity] = useState(null);
	const [currentBrand, setCurrentBrand] = useState(null);

	const login = useSelector((state) => state.auth.login);

	const adminPermission = JSON.parse(localStorage.getItem("adminPermission"));
	const isNewAdmin = adminPermission?.newAdmin;

	const location = useLocation();

	const refIsNewAdmin = isNewAdmin
		? `/web/settings/city/${currentCity}/brands/${currentBrand}/category/productsTags`
		: `/web/settings/city/${currentCity}/category/productsTags`;

	useEffect(() => {
		getFieldsLabels();
	}, [location.pathname]);

	const getFieldsLabels = () => {
		const currentCity = JSON.parse(localStorage.getItem("chosenCity"));
		const currentBrand = JSON.parse(localStorage.getItem("chosenBrand"));
		const isDebug = JSON.parse(localStorage.getItem("isDebug"));

		const refIsNewAdmin = isNewAdmin
			? `web/settings/city/${currentCity}/brands/${currentBrand}/category/productsTags`
			: `web/settings/city/${currentCity}/category/productsTags`;

		const refPath = `${isDebug ? "debug" : ""}${refIsNewAdmin}`;

		firebase.bd
			.ref(`${refPath}/tags`)
			.once("value")
			.then((snapshot) => {
				const tagsData = snapshot.val();

				setLabels(tagsData || []);
				setCurrentCity(currentCity);
				setCurrentBrand(currentBrand);
			})
			.catch((error) => {
				console.error("Labels fetch error:", error);
			});
	};

	const changeChecker = useCallback(
		(value, id) => {
			console.log("id (changeChecker) --- >", id);
			const isDebug = JSON.parse(localStorage.getItem("isDebug"));
			setPreloader(true);

			firebase.bd
				.ref(`${isDebug ? "debug" : ""}${refIsNewAdmin}/tags/${id}`)
				.update({ isActive: value })
				.then(() => {
					setPreloader(false);
					getFieldsLabels();
				});
		},
		[currentCity, currentBrand, firebase.bd]
	);

	const deleteLabel = useCallback(
		(id) => {
			console.log("=== Delete label ===", id);
			const isDebug = JSON.parse(localStorage.getItem("isDebug"));
			setPreloader(true);

			let img = labels.find((item, index) => {
				return index === +id;
			});

			console.log("img", img);

			const updatedLabels = labels.filter((_, index) => index !== +id);

			setLabels(updatedLabels);

			firebase.bd
				.ref(`${isDebug ? "debug" : ""}${refIsNewAdmin}/tags`)
				.set(updatedLabels)
				.then(() => {
					if (img) {
						handleDeleteImg({ id: Date.now(), name: img.image });
						isDeleteProductTags(updatedLabels);
						getFieldsLabels();
					}
					setPreloader(false);
					getFieldsLabels();
				})
				.catch((error) => {
					console.error("Error deleting label:", error);
					setPreloader(false);
				});
		},

		[currentCity, currentBrand, firebase.bd, getFieldsLabels]
	);

	const isDeleteProductTags = (data) => {
		const isDebug = JSON.parse(localStorage.getItem("isDebug"));

		if (Object.keys(data).length < 1) {
			firebase.bd
				.ref(`${isDebug ? "debug" : ""}${refIsNewAdmin}`)
				.remove()
				.then(() => {
					console.log("productTags removed.");
					setPreloader(false);
					getFieldsLabels();
				})
				.catch((error) => {
					console.error("productTags delete error:", error);
					setPreloader(false);
				});
		}
	};
	const createLabel = useCallback((data) => {
		console.log("=== Create label data ===", data);
		const isDebug = JSON.parse(localStorage.getItem("isDebug"));

		setPreloader(true);

		const refPath = `${isDebug ? "debug" : ""}${refIsNewAdmin}`;

		firebase.bd
			.ref(refPath)
			.once("value")
			.then((snapshot) => {
				const productTagsData = snapshot.val();

				if (!productTagsData) {
					console.log("product tags");
					firebase.bd.ref(refPath).set({ isTagsAvailable: true });
				}

				firebase.bd
					.ref(`${isDebug ? "debug" : ""}${refIsNewAdmin}/tags`)
					.once("value")
					.then((snapshot) => {
						const existingTags = snapshot.val() || [];
						const filteredTags = existingTags.filter(
							(tag) => tag !== undefined
						);
						const updatedTags = [...filteredTags, data];

						firebase.bd
							.ref(`${isDebug ? "debug" : ""}${refIsNewAdmin}/tags`)
							.set(updatedTags)
							.then(() => {
								setPreloader(false);
								// window.location.reload();
								getFieldsLabels();
							})
							.catch((error) => {
								console.error("Error adding label:", error);
								setPreloader(false);
							});
					})
					.catch((error) => {
						console.error("Error fetching tags:", error);
						setPreloader(false);
					});
			});
	});

	const updateLabel = useCallback(
		(labelId, updatedData) => {
			console.log("=== Update label data ===", labelId, updatedData);
			const isDebug = JSON.parse(localStorage.getItem("isDebug"));
			setPreloader(true);

			firebase.bd
				.ref(`${isDebug ? "debug" : ""}${refIsNewAdmin}/tags/${labelId}`)
				.update(updatedData)
				.then(() => {
					setPreloader(false);
					getFieldsLabels();
				})
				.catch((error) => {
					console.error("Error updating label:", error);
					setPreloader(false);
				});
		},
		[currentCity, currentBrand, firebase.bd, getFieldsLabels]
	);

	const uploadImage = async ({ file }) => {
		console.log("file", file);
		console.log("login", login);

		if (!file || !login) throw new Error(t("labels.errors.missingFileOrLogin"));

		const MAX_SIZE = 512 * 1024;

		if (file.size > MAX_SIZE) {
			throw new Error(t("labels.errors.fileTooLarge"));
		}

		const formData = new FormData();
		formData.append("photo", file);
		formData.append("login", login);
		formData.append("folder", "loyalty-system");

		const response = await axios.post(
			`https://e-admin.com.ua/photo/index.php`,
			formData
		);

		if (response.data && response.data.image_name) {
			const namePhoto = response.data.image_name.split(" ")[0];
			return `https://e-admin.com.ua/photo/photo/uploads/${login}/loyalty-system/${namePhoto}`;
		} else {
			throw new Error(t("labels.errors.imageName"));
		}
	};

	const handleDeleteImg = async ({ id, name }) => {
		console.log("detlete img");
		const url = `https://e-admin.com.ua/photo/deleteBanner.php`;
		const payload = {
			id,
			name,
			login,
			folder: "loyalty-system",
		};

		console.log("payload", payload);

		const response = await fetch(url, {
			method: "POST",
			body: JSON.stringify(payload),
		});

		console.log("response", response.ok);

		if (!response.ok) {
			throw new Error(t("labels.errors.deleteImage"));
		}

		return { message: `Photo ${name} was deleted from server` };
	};
	const deleteBanner = () => {};

	return (
		<div>
			<Labels
				updateLabel={updateLabel}
				loadStatus={preloader}
				labels={labels}
				changeChecker={changeChecker}
				createLabel={createLabel}
				deleteLabel={deleteLabel}
				uploadImage={uploadImage}
				handleDeleteImg={handleDeleteImg}
				deleteBanner={deleteBanner}
			/>
		</div>
	);
};

export default withFirebase(LabelsContainer);
